import './../../../scss/module/review/review.scss'

document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('review-form');
  if (!form || !form.classList.contains('collapse')) return;
  var hasErrors = form.querySelector(
    '.is-invalid, .invalid-feedback, [aria-invalid="true"]'
  );
  // Deep-link from a review-collection email/SMS: ?avis=1 pre-opens the form.
  var wantsReview = /[?&]avis=1(&|$)/.test(window.location.search);
  if (!hasErrors && !wantsReview) return;
  if (!form.classList.contains('show')) form.classList.add('show');
  var btn = document.querySelector(
    '[data-bs-toggle="collapse"][data-bs-target="#review-form"]'
  );
  if (btn) btn.setAttribute('aria-expanded', 'true');
  form.scrollIntoView({behavior: 'smooth', block: 'center'});
  var firstInvalid = form.querySelector(
    'input.is-invalid, textarea.is-invalid, select.is-invalid'
  );
  var focusable = firstInvalid ||
    form.querySelector('input, textarea, select');
  if (focusable && focusable.focus) focusable.focus({preventScroll: true});
});

// Loads the remaining Google reviews into the concessionary slider as it
// nears its right edge. The contract with the template is the `data-*` on
// `.google-reviews`; the card markup comes from the server.
document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.google-reviews[data-reviews-url]');
  if (!root) return;
  var content = root.querySelector('.slider-content');
  var url = root.getAttribute('data-reviews-url');
  if (!content || !url) return;

  var page = parseInt(root.getAttribute('data-next-page'), 10) || 2;
  var total = parseInt(root.getAttribute('data-total'), 10) || 0;
  var hasMore = content.children.length < total;
  var loading = false;
  // A card is 340px wide: fire a little before the edge so the next ones are
  // already there on arrival.
  var THRESHOLD = 400;

  function shouldLoad() {
    if (!hasMore || loading) return false;
    // While the cards do not overflow, no scroll is possible and the `scroll`
    // event never comes, so load right away or the last reviews stay out of
    // reach on a wide screen.
    if (content.scrollWidth <= content.clientWidth + 1) return true;
    var remaining = content.scrollWidth - content.clientWidth
      - content.scrollLeft;
    return remaining <= THRESHOLD;
  }

  function load() {
    loading = true;
    fetch(url + '?page=' + page, {
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    }).then(function (data) {
      if (data.html) content.insertAdjacentHTML('beforeend', data.html);
      page += 1;
      hasMore = Boolean(data.has_more);
      loading = false;
      // The cards just added may not fill the slider either.
      if (shouldLoad()) load();
    }).catch(function () {
      // Stop on what is displayed rather than loop on a failing request.
      hasMore = false;
      loading = false;
    });
  }

  function maybeLoad() {
    if (shouldLoad()) load();
  }

  content.addEventListener('scroll', maybeLoad, {passive: true});
  window.addEventListener('resize', maybeLoad, {passive: true});
  // The "next" button scrolls through a jQuery animation (base.js) that does
  // emit `scroll`. The click is still watched because when the cards do not
  // overflow yet the animation moves nothing -- and that is exactly when the
  // next page is needed.
  var next = root.querySelector('[data-action-pagination="next"]');
  if (next) next.addEventListener('click', maybeLoad);
  maybeLoad();
});
